export default class StampController {

    constructor(world) {
        this.world = world

        this.stampsById = {}
        this.subCategoryMap = {}
        this.totalStampsCache = {}
        this.groupMap = {}

        const stampGroups = Array.isArray(this.world.crumbs?.stamps) ? this.world.crumbs.stamps : []

        for (const group of stampGroups) {
            if (!group || !Array.isArray(group.stamps)) {
                continue
            }

            for (const stamp of group.stamps) {
                if (!stamp || typeof stamp.stamp_id === 'undefined') {
                    continue
                }
                this.stampsById[stamp.stamp_id] = stamp
            }

            if (!(group.parent_group_id in this.subCategoryMap)) {
                this.subCategoryMap[group.parent_group_id] = []
            }
            this.subCategoryMap[group.parent_group_id].push(group)

            this.groupMap[group.group_id] = group
        }
    }

    get all() {
        const allStamps = []
        const stampGroups = Array.isArray(this.world.crumbs?.stamps) ? this.world.crumbs.stamps : []

        for (const group of stampGroups) {
            if (group?.stamps) {
                allStamps.push(...group.stamps)
            }
        }

        return allStamps
    }

    getStamp(stampId) {
        return this.stampsById[stampId] || null
    }

    getSubGroups(groupId) {
        return this.subCategoryMap[groupId] || null
    }

    getGroup(groupId) {
        return this.groupMap[groupId] || null
    }

    totalStamps(groupId) {
        if (this.totalStampsCache[groupId]) {
            return this.totalStampsCache[groupId]
        }

        const group = this.groupMap[groupId]
        if (!group) {
            return []
        }

        const stamps = Array.isArray(group.stamps) ? [...group.stamps] : []
        const childGroups = this.subCategoryMap[group.group_id] || []

        for (const child of childGroups) {
            stamps.push(...this.totalStamps(child.group_id))
        }

        this.totalStampsCache[groupId] = stamps
        return stamps
    }

    filteredStampsForTotal(unlockedStamps, groupId) {
        if (!Array.isArray(unlockedStamps)) {
            return []
        }

        const stamps = this.totalStamps(groupId).map(stamp => stamp.stamp_id)
        return unlockedStamps.filter(id => stamps.includes(id))
    }

}
